<script>
// import axios from "axios";

import Layout from "../../../layouts/main";
// import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { required, minValue } from "vuelidate/lib/validators";
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
// import Loader from "@/components/widgets/loader";
// import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import Vue from "vue";
// import Vuetable from "vuetable-2";
// import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import { FulfillingBouncingCircleSpinner } from "epic-spinners";
import { helpers } from "../../../../helpers/helpers-validate";
import MaskedInput from "vue-text-mask";
// import Switches from "vue-switches";
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { authComputed } from "@/state/helpers";
// import vSelect from "vue-select";
// Vue.component("v-select", vSelect);
// register the plugin on vue
import Toasted from "vue-toasted";

Vue.use(Toasted);
// Lets Register a Global Error Notification Toast.
let nit = (value) => helpers.nitIsValid(value);
let correo = (value) => helpers.correo(value);
/**
 * new orden component
 */
export default {
  page: {
    title: "Nueva venta",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    // PageHeader,
    DatePicker,
    // Switches,
    // Vuetable,
    // VuetablePagination,
    // Loader,
    // vSelect,
    "fulfilling-bouncing-circle-spinner": FulfillingBouncingCircleSpinner,
    "masked-input": MaskedInput,
  },
  data() {
    return {
      // variables metodos
      estadosRevision: [
        { id: 1, valor: 'RECIBIDO' },
        { id: 2, valor: 'DIAGNOSTICO' },
        { id: 3, valor: 'REPARACIÓN' },
        { id: 4, valor: 'TERMINADO' },
        // { id: 5, valor: 'ENTREGADO' }
      ],// Array de opciones para los botones de radio
      selectedOption: '' ,
      idCaja: 0,
      userT: this.$store.state.authfack.user,
      bandera: false,
      httpOptions: {
        headers: { "x-token": this.$store.state.authfack.user.token },
      },
      cantidad_efectivo: "",
      transferencia: [
        {
          cantidad_transferencia: "",
          transaccion_transferencia: "",
          button: true,
        },
      ],
      deposito: [
        {
          cantidad_deposito: "",
          transaccion_deposito: "",
          button: true,
        },
      ],
      cheque: [
        {
          cantidad_cheque: "",
          transaccion_cheque: "",
          button: true,
        },
      ],
      tarjeta: [
        {
          cantidad_tarjeta: "",
          transaccion_tarjeta: "",
          button: true,
        },
      ],
      checkMoney: {
        efectivo: false,
        transferencia: false,
        deposito: false,
        cheque: false,
        tarjeta: false,
      },
      checkSelect: {
        efectivo: false,
        transferencia: false,
        deposito: false,
        cheque: false,
        tarjeta: false,
      },
      montoFinal: {
        cantidad: 0,
        metodo: "",
        transaccion: "",
      },
      montos: {
        monto_efectivo: "",
        monto_transferencia: [],
        monto_deposito: [],
        monto_cheque: [],
        monto_tarjeta: [],
      },
      // variable credito
      formCredito: {
        color: false,
        asignado: false,
        fechaInicio: new Date(),
        intervalo: 7,
        collapse1: false,
        pagos: [],
        precioNuevo: 0,
        adelanto: "0",
        cantidadPagos: 0,
      },
      // variables nuevas
      porcentaje: "",
      indexPorcentaje: "",
      precioOriginal: "",
      precioDescuento: "",
      arrayProductos: [],
      producto: "",
      arrayServicios: [],
      servicio: "",
      busquedaLabel2: { nombre: "Código", value: "codigo" },
      busquedaLabel: { nombre: "Nombre", value: "producto" },
      busquedaTipos: [
        { nombre: "Nombre", value: "producto" },
        { nombre: "Código", value: "codigo" },
      ],
      busquedaTipos2: [{ nombre: "Código", value: "codigo" }],
      fieldsProductos: [
        { key: "action", label: "Acciones" },
        { key: "codigo", label: "Código" },
        { key: "producto", label: "Producto" },
        { key: "existencia", label: "Existencia" },
        { key: "departamento", label: "Ubicación" },
        { key: "precio_venta", label: "Precio venta" },
      ],
      fieldsServicios: [
        { key: "action", label: "Acciones" },
        { key: "nombre_servicio", label: "Servicio" },
        { key: "descripcion_servicio", label: "Descripción" },
      ],
      fechaVec: "",
      switchCliente: false,
      formCliente: {
        nombre: "",
        apellido: "",
        nit: "C/F",
        opciones: ["MASCULINO", "FEMENINO"],
        direccion: "",
        telefono: "",
        telefono_cliente: "",
        correo: "",
        cui: "",
        sexo: "",
        compania: "",
        direc: "",
        state: true,
        id: 0,
      },
      // variables para detalle
      ubicacionModel: 0,
      arrayEstante: [],
      estanteModel: 0,
      formget: {
        descripcion: "",
        pasillo: "",
        seccion: "",
        estante: "",
        departamentoId: "",
        id: 0,
      },
      activa_cliente: false,
      cabezera: [
        { key: "Opciones", label: "Opciones" },
        { key: "codigo", label: "Código" },
        { key: "producto", label: "Producto" },
        { key: "existencia", label: "Existencia" },
        { key: "cantidad", label: "Cantidad", thStyle: { width: "9%" } },
        {
          key: "precio_venta",
          label: "Precio Venta",
          thStyle: { width: "20%" },
        },
        { key: "subtotal", label: "Subtotal" },
      ],
      cabezera2: [
        { key: "Opciones", label: "Opciones" },
        { key: "nombre_servicio", label: "Servicio" },
        { key: "descripcion_servicio", label: "Descripción" },
        { key: "cantidad", label: "Cantidad", thStyle: { width: "9%" } },
        {
          key: "precio_venta",
          label: "Precio Venta",
          thStyle: { width: "20%" },
        },
        { key: "subtotal", label: "Subtotal" },
      ],
      arrayCliente: [],
      arrayDepa: [],
      arrayClientes: [],
      apiUrl: process.env.VUE_APP_URL,
      apiBase:
        process.env.VUE_APP_URL +
        "productos/stock/busqueda?departamento=" +
        0 +
        "&estante=" +
        0,
      apiBase2: process.env.VUE_APP_URL + "servicios/select",
      css: {
        table: {
          tableClass: "table table-striped table-bordered table-hovered",
          loadingClass: "loading",
          ascendingIcon: "glyphicon glyphicon-chevron-up",
          descendingIcon: "glyphicon glyphicon-chevron-down",
          handleIcon: "glyphicon glyphicon-menu-hamburger",
        },
        pagination: {
          infoClass: "pull-left",
          wrapperClass: "vuetable-pagination pull-right",
          activeClass: "btn-primary",
          disabledClass: "disabled",
          pageClass: "btn btn-border",
          linkClass: "btn btn-border",
          icons: {
            first: "",
            prev: "",
            next: "",
            last: "",
          },
        },
      },
      formPro: {
        fecha_compra: new Date(),
        tiendaid: "",
        observaciones: "",
        tienda: "",
        cliente: null,
        total: "",
        total_servicios: "",
        total_productos: "",
        state: true,
        id: 0,
        auto: null ,
        modelo: null,
        placas: '',
        anio: '',
        observaciones_mecanico: '',
        observacion_general:''
      },
      data: [
        {
          nombre: "",
          cantidad: "",
          precio_compra: "",
          porcentaje_venta: "",
          precio_venta: "",
          subtotal: "",
          ubicacion: "",
          sub_presentacion: "",
          button: true,
        },
      ],
      title: "NUEVA VENTA",
      items: [
        {
          text: "Ventas",
          href: "/",
        },
        {
          text: "Nueva venta",
          active: true,
        },
      ],
      searchType: [
        { nombre: "Producto", value: "producto" },
        { nombre: "Codigo", value: "codigo" },
      ],
      searchType2: [{ nombre: "Nombre", value: "nombre" }],
      options: {
        theme: "outline",
        position: "top-right",
        duration: 5000,
        keepOnHover: true,
        action: {
          text: "X",
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          },
        },
      },
      optionsFast: {
        theme: "outline",
        position: "top-right",
        duration: 2000,
        keepOnHover: true,
        action: {
          text: "X",
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          },
        },
      },
      loadingtable: false,
      sortBy: "nombre_producto",
      sortDesc: false,
      searchLabel: { nombre: "Producto", value: "producto" },
      filterLabel: { nombre: "Codigo", value: "codigo" },
      searchLabel2: { nombre: "Nombre", value: "nombre" },
      filterLabel2: { nombre: "Nombre", value: "nombre" },
      showModalL: false, //Loading
      showModalNP: false, //Nuevo cliente
      showModalN: false, //Nuevo registro
      showModalD: false, //Desactivar
      showModalA: false, //Activar
      pageOptions: [4, 10, 15, 20],
      search: "",
      search2: "",
      page: 1,
      perPage: 4,
      from: 0,
      to: 0,
      to2: 0,
      total: 0,
      total2: 0,
      lastPage: 0,
      lastPage2: 0,
      arrayDetalle: [],
      arrayDetalleServicio: [],
      idDepartamento: 0,
      traslado_masivo: false,
      arrayDet: [],
      idCliente: -1,
      isLoad: false,
      mask_porcentaje: createNumberMask({
        prefix: "",
        suffix: " %",
        includeThousandsSeparator: true,
        thousandsSeparatorSymbol: ",",
        allowDecimal: true,
        decimalSymbol: ".",
        decimalLimit: 2, // how many digits allowed after the decimal
        integerLimit: 10, // limit length of integer numbers
        allowNegative: false,
        allowLeadingZeroes: false,
      }),
      mask_quetzal: createNumberMask({
        prefix: "Q ",
        suffix: "",
        includeThousandsSeparator: true,
        thousandsSeparatorSymbol: ",",
        allowDecimal: true,
        decimalSymbol: ".",
        decimalLimit: 2, // how many digits allowed after the decimal
        integerLimit: 10, // limit length of integer numbers
        allowNegative: false,
        allowLeadingZeroes: false,
      }),
    };
  },
  validations: {
    formCliente: {
      nombre: { required },
      apellido: { required },
      nit: { nit, required },
      direccion: { required },
      telefono: { required },
      correo: { correo, required },
      cui: { required },
      sexo: { required },
      compania: { required },
      direc: { required },
      //telefono_cliente: {required},
    },
    formPro: {
      fecha_compra: { required },
      tienda: { required },
      cliente: { required },
      total: { required },
    },
    arrayDetalle: {
      $each: {
        subtotal: {
          required,
          minValue: minValue(1),
        },
        // precio_compra: {
        //   required,
        //   minValue: minValue(1),
        // },
        // precio_venta: {
        //   required,
        //   minValue: minValue(1),
        // },
        // ubicacion: {
        //   required,
        // },
      },
    },
    arrayDetalleServicio: {
      $each: {
        subtotal: {
          required,
          minValue: minValue(1),
        },
        // precio_venta: {
        //   required,
        //   minValue: minValue(1),
        // },
      },
    },
    data: { required },
    cantidad_efectivo: {
      required,
      // minValue: minValue(1),
    },
    transferencia: {
      required,
      $each: {
        cantidad_transferencia: {
          required,
          // minValue: minValue(1),
        },
        transaccion_transferencia: {
          required,
        },
      },
    },
    deposito: {
      required,
      $each: {
        cantidad_deposito: {
          required,
          // minValue: minValue(1),
        },
        transaccion_deposito: {
          required,
        },
      },
    },
    cheque: {
      required,
      $each: {
        cantidad_cheque: {
          required,
          // minValue: minValue(1),
        },
        transaccion_cheque: {
          required,
        },
      },
    },
    tarjeta: {
      required,
      $each: {
        cantidad_tarjeta: {
          required,
          // minValue: minValue(1),
        },
        transaccion_tarjeta: {
          required,
        },
      },
    },
    montoFinal: {
      cantidad: {
        minValue: minValue(1),
      },
    },
  },
  updated() {
    // this.$refs["inputCliente"].focus();
    // this.detalle();
  },
  async mounted() {
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: { "x-token": usuario.token },
      })
        .then((res) => {
          if (res.data.success) {
            // this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
          location.reload();
        });
    }
    // this.getClientes();
    // this.gettienda();
    await axios
      .get(this.apiUrl + "clientes/cf", {
            headers: { "x-token": this.userT.token },
          })
      .then(({ data }) => {
        //  console.log('mounted', data);
         this.formPro.cliente = {
          id: data.clientes.id,
          nombre: data.clientes.nombre,
          nit_cliente: data.clientes.nit_cliente,
          persona: data.clientes.persona,
        };
        this.idCliente = data.clientes.id;
      })
      .catch(console.error);
      this.validarCaja();
      this.detalle();
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
    calcularTotal: function () {
      let sum1 = 0.0;
      let sum2 = 0.0;
      let resultado = 0.0;
      if (this.arrayDetalle.length > 0) {
        for (let i = 0; i < this.arrayDetalle.length; i++) {
          if (
            this.arrayDetalle[i].subtotal == "" ||
            this.arrayDetalle[i].subtotal == null
          ) {
            sum1 = 0;
          } else {
            sum1 = parseFloat(sum1) + parseFloat(this.arrayDetalle[i].subtotal);
          }
        }
      }
      if (this.arrayDetalleServicio.length > 0) {
        for (let i = 0; i < this.arrayDetalleServicio.length; i++) {
          if (
            this.arrayDetalleServicio[i].subtotal == "" ||
            this.arrayDetalleServicio[i].subtotal == null
          ) {
            sum2 = 0;
          } else {
            sum2 =
              parseFloat(sum2) +
              parseFloat(this.arrayDetalleServicio[i].subtotal);
          }
        }
      }
      resultado = sum1 + sum2;
      return resultado.toFixed(2);
    },
    calcularProductos: function () {
      let sum1 = 0.0;
      if (this.arrayDetalle.length > 0) {
        for (let i = 0; i < this.arrayDetalle.length; i++) {
          if (
            this.arrayDetalle[i].subtotal == "" ||
            this.arrayDetalle[i].subtotal == null
          ) {
            sum1 = 0;
          } else {
            sum1 = parseFloat(sum1) + parseFloat(this.arrayDetalle[i].subtotal);
          }
        }
      }
      return sum1.toFixed(2);
    },
    calcularServicios: function () {
      let sum2 = 0;
      if (this.arrayDetalleServicio.length > 0) {
        for (let i = 0; i < this.arrayDetalleServicio.length; i++) {
          if (
            this.arrayDetalleServicio[i].subtotal == "" ||
            this.arrayDetalleServicio[i].subtotal == null
          ) {
            sum2 = 0;
          } else {
            sum2 =
              parseFloat(sum2) +
              parseFloat(this.arrayDetalleServicio[i].subtotal);
          }
        }
      }
      return sum2.toFixed(2);
    },
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    detalle() {
      let me = this;
    // console.log(this.$route.params.id)
        let arregloProd = [];
        let arregloServicio = [];
      axios
        .get(
          process.env.VUE_APP_URL +
            "ordenes/view?id=" +
            this.$route.params.id,
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then((response) => {
          console.log("response", response.data.respuesta);
        //   me.detalleProducto = response.data.orden.detalle_ventas;
        //   me.detalleServicio = response.data.orden.detalle_servicio_vs;
        //   // console.log(this.detalleProducto);
        //   // console.log(this.detalleServicio);
          me.formPro.cliente = response.data.respuesta.vehiculo.cliente.persona.nombre_persona + ' ' + response.data.respuesta.vehiculo.cliente.persona.apellido_persona;
          me.formPro.auto = response.data.respuesta.vehiculo.modelo.auto.nombre_auto;
          me.formPro.modelo = response.data.respuesta.vehiculo.modelo.nombre_modelo;
          me.formPro.placas = response.data.respuesta.vehiculo.placa;
          me.formPro.anio = response.data.respuesta.vehiculo.anio;
          me.formPro.observaciones = response.data.respuesta.observacion_cliente;
          me.formPro.observaciones_mecanico = response.data.respuesta.observacion_mecanico;
          me.formPro.observacion_general = response.data.respuesta.observaciones;
          arregloProd = response.data.respuesta.detalle_prod_servs;
          arregloServicio = response.data.respuesta.detalle_serv_servs;
          me.selectedOption =response.data.respuesta.estado_diagnostico;
        //   me.formPro.fecha_venta = response.data.orden.fecha_venta;
        //   me.formPro.total = response.data.orden.total;
        //   me.formPro.direccionp = "Guatemala";
        //   me.formPro.state = response.data.orden.estado_venta;
        // console.log(me.formPro)
        }).finally(()=>{
            console.log(arregloProd,arregloServicio );
            if(arregloProd.length > 0 || arregloServicio.length>0){
                me.arrayDetalle = arregloProd.map(objeto => {
                    // Aquí puedes realizar cualquier operación con el objeto
                    return { 
                            id : objeto.producto.id,
                            inventarioProductoId : objeto.inventario_producto.id,
                            precio_compra: objeto.precio_compra,
                            precio_venta: objeto.precio_venta,
                            precio_original: objeto.precio_venta,
                            validate1: false,
                            validate2: false,
                        
                            codigo: objeto.producto.codigo_stock,
                            departamento: objeto.inventario_producto.bodega.nombre_bodega,
                    
                            producto: objeto.producto.nombre_producto,
                            imagen_stock: objeto.producto.imagen_stock,
                            cantidad: objeto.cantidad_venta,
                            existencia_actual: objeto.inventario_producto.existencia,
                        
                            subtotal: objeto.subtotal_venta
                    };
                });
                me.arrayDetalleServicio = arregloServicio.map(objeto => {
                    // Aquí puedes realizar cualquier operación con el objeto
                    return { 
                        nombre_servicio: objeto.servicio.nombre_servicio,
                        descripcion_servicio: objeto.servicio.descripcion_servicio,
                        cantidad: objeto.cantidad_servicios,
                        subtotal: objeto.subtotal_servicio,
                        precio_venta: objeto.precio_servicio,
                        id: objeto.servicio.id,
                    };
                });
            }
        });
    },
    validarCaja() {
      // let me = this;
      axios
          .get(
              process.env.VUE_APP_URL +
              "caja/get_validate?" +
              "&usuario=" +
              this.userT.id + "&tienda=" + this.$store.state.authfack.user.tienda,
              {
                headers: {"x-token": this.userT.token},
              }
          )
          .then((response) => {
            this.idCaja = response.data.validate.id
            // console.log(this.idCaja);
          });
    },
    async focus(number) {
      if (number == 1) {
        setTimeout(() => {
          this.$refs["inputProductos"].focus();
        }, 300);
      }
      if (number == 2) {
        setTimeout(() => {
          this.$refs["inputServicios"].focus();
        }, 300);
      }
      if (number == 3) {
        setTimeout(() => {
          this.$refs["inputCredito1"].focus();
        }, 300);
      }
    },
    validarCredito() {
      const { intervalo, precioNuevo, adelanto, cantidadPagos } =
        this.formCredito;

      if (
        intervalo > 0 &&
        precioNuevo > 0 &&
        adelanto >= 0 &&
        cantidadPagos > 0
      ) {
        this.calcularCredito();
      } else {
        Vue.toasted.error("Complete los campos de crédito", this.options);
      }
    },
    calcularCredito() {
      this.formCredito.pagos = [];
      let pagosTemporal = [];
      let {
        intervalo,
        precioNuevo,
        // adelanto,
        fechaInicio,
        // collapse1,
        pagos,
        cantidadPagos,
      } = this.formCredito;

      const cantidad = precioNuevo / cantidadPagos;
      // this.formCredito.pagos = [];
      for (let i = 0; i < cantidadPagos; i++) {
        if (i == 0) {
          pagosTemporal.push({
            fecha1: fechaInicio,
            fecha2: moment(fechaInicio).add(intervalo, "days"),
          });
        } else {
          pagosTemporal.push({
            fecha1: pagosTemporal[i - 1].fecha2,
            fecha2: moment(pagosTemporal[i - 1].fecha2).add(intervalo, "days"),
          });
        }
        pagos.push({
          monto_pago: cantidad,
          fecha_pago: this.customFormatter(pagosTemporal[i].fecha1),
        });
      }
    },
    validarModalCredito() {
      if (this.formCredito.collapse1 == true) {
        const { pagos, intervalo, precioNuevo, adelanto, cantidadPagos } =
          this.formCredito;
        if (
          intervalo > 0 &&
          precioNuevo > 0 &&
          adelanto >= 0 &&
          cantidadPagos > 0 &&
          pagos.length > 0
        ) {
          if (this.montoFinal.cantidad > 0) {
            if (
              this.checkMoney.efectivo ||
              this.checkMoney.transferencia ||
              this.checkMoney.deposito ||
              this.checkMoney.cheque ||
              this.checkMoney.tarjeta
            ) {
              this.bandera = false;
              if (this.checkMoney.efectivo) {
                if (this.converMaskToNumberxd(this.cantidad_efectivo) == "") {
                  this.bandera = true;
                  Vue.toasted.error("Agregue monto en efectivo", this.options);
                } else {
                  this.montos.monto_efectivo = parseFloat(
                    this.converMaskToNumberxd(this.cantidad_efectivo)
                  );
                }
              }
              if (this.checkMoney.transferencia) {
                let temp = 0;
                for (let i = 0; i < this.transferencia.length; i++) {
                  if (
                    this.transferencia[i].cantidad_transferencia == "" ||
                    this.transferencia[i].transaccion_transferencia == ""
                  ) {
                    temp++;
                  }
                }
                if (temp > 0) {
                  this.bandera = true;
                  Vue.toasted.error(
                    "Complete campos de transferencia",
                    this.options
                  );
                } else {
                  this.montos.monto_transferencia = [];
                  for (let i = 0; i < this.transferencia.length; i++) {
                    this.montos.monto_transferencia.push({
                      monto_transferencia: parseFloat(
                        this.converMaskToNumberxd(
                          this.transferencia[i].cantidad_transferencia
                        )
                      ),
                      transaccion_transferencia:
                        this.transferencia[i].transaccion_transferencia,
                    });
                  }
                }
              }
              if (this.checkMoney.deposito) {
                let temp = 0;
                for (let i = 0; i < this.deposito.length; i++) {
                  if (
                    this.deposito[i].cantidad_deposito == "" ||
                    this.deposito[i].transaccion_deposito == ""
                  ) {
                    temp++;
                  }
                }
                if (temp > 0) {
                  this.bandera = true;
                  Vue.toasted.error(
                    "Complete campos de deposito",
                    this.options
                  );
                } else {
                  this.montos.monto_deposito = [];
                  for (let i = 0; i < this.deposito.length; i++) {
                    this.montos.monto_deposito.push({
                      monto_deposito: parseFloat(
                        this.converMaskToNumberxd(
                          this.deposito[i].cantidad_deposito
                        )
                      ),
                      transaccion_deposito:
                        this.deposito[i].transaccion_deposito,
                    });
                  }
                }
              }
              if (this.checkMoney.cheque) {
                let temp = 0;
                for (let i = 0; i < this.cheque.length; i++) {
                  if (
                    this.cheque[i].cantidad_cheque == "" ||
                    this.cheque[i].transaccion_cheque == ""
                  ) {
                    temp++;
                  }
                }
                if (temp > 0) {
                  this.bandera = true;
                  Vue.toasted.error("Complete campos de cheque", this.options);
                } else {
                  this.montos.monto_cheque = [];
                  for (let i = 0; i < this.cheque.length; i++) {
                    this.montos.monto_cheque.push({
                      monto_cheque: parseFloat(
                        this.converMaskToNumberxd(
                          this.cheque[i].cantidad_cheque
                        )
                      ),
                      transaccion_cheque: this.cheque[i].transaccion_cheque,
                    });
                  }
                }
              }
              if (this.checkMoney.tarjeta) {
                let temp = 0;
                for (let i = 0; i < this.tarjeta.length; i++) {
                  if (
                    this.tarjeta[i].cantidad_tarjeta == "" ||
                    this.tarjeta[i].transaccion_tarjeta == ""
                  ) {
                    temp++;
                  }
                }
                if (temp > 0) {
                  this.bandera = true;
                  Vue.toasted.error("Complete campos de tarjeta", this.options);
                } else {
                  this.montos.monto_tarjeta = [];
                  for (let i = 0; i < this.tarjeta.length; i++) {
                    this.montos.monto_tarjeta.push({
                      monto_tarjeta: parseFloat(
                        this.converMaskToNumberxd(
                          this.tarjeta[i].cantidad_tarjeta
                        )
                      ),
                      transaccion_tarjeta: this.tarjeta[i].transaccion_tarjeta,
                    });
                  }
                }
              }
              if (this.bandera == false) {
                if (
                  this.montoFinal.cantidad ==
                  parseFloat(
                    this.converMaskToNumberxd(this.formCredito.adelanto)
                  )
                ) {
                  // this.showModalL = true;
                  this.asignarCredito();
                } else {
                  Vue.toasted.error(
                    `La cantidad actual no coincide con el monto a pagar. La diferencia es de <strong>${this.formatQuetzales(
                      this.montoFinal.cantidad -
                        parseFloat(
                          this.converMaskToNumberxd(this.formCredito.adelanto)
                        )
                    )}</strong>`,
                    this.options
                  );
                }
              } else {
                Vue.toasted.error(
                  "Ingrese cantidades en los métodos de pago",
                  this.options
                );
              }
            } else {
              Vue.toasted.error(
                "Seleccione al menos un método de pago",
                this.options
              );
            }
          } else {
            Vue.toasted.error("Agregue métodos de pago", this.options);
          }
        } else {
          Vue.toasted.error("Complete los campos de crédito", this.options);
        }
      } else {
        const { pagos, intervalo, precioNuevo, adelanto, cantidadPagos } =
          this.formCredito;
        if (
          intervalo > 0 &&
          precioNuevo > 0 &&
          adelanto >= 0 &&
          cantidadPagos > 0 &&
          pagos.length > 0
        ) {
          this.asignarCredito();
        } else {
          Vue.toasted.error("Complete los campos de crédito", this.options);
        }
      }
    },
    asignarCredito() {
      this.formCredito.color = true;
      this.formCredito.asignado = true;
      Vue.toasted.success("Crédito asignado", this.options);
      this.$refs["modalCredito"].hide();
    },
    asignarAdelanto() {
      this.formCredito.pagos = [];
      this.formCredito.fechaInicio = new Date();
      this.formCredito.intervalo = 7;
      this.formCredito.cantidadPagos = 0;

      // let adelantoTemp = parseFloat(this.converMaskToNumberxd(this.formCredito.adelanto))

      if (this.formCredito.adelanto > 0) {
        // console.log("a");
        this.formCredito.collapse1 = true;
        this.formCredito.precioNuevo =
          this.formPro.total - this.formCredito.adelanto;
      } else {
        this.formCredito.precioNuevo = this.formPro.total;
        this.formCredito.collapse1 = false;
      }
    },
    resetCredito() {
      // Reset credito
      this.formCredito.precioNuevo = this.formPro.total;
      this.formCredito.color = false;
      this.formCredito.asignado = false;
      this.formCredito.intervalo = 7;
      this.formCredito.collapse1 = false;
      this.formCredito.pagos = [];
      this.formCredito.adelanto = "0";
      this.formCredito.cantidadPagos = 0;

      //  Reset metodos de pago
      this.bandera = false;
      this.cantidad_efectivo = "";
      this.transferencia = [
        {
          cantidad_transferencia: "",
          transaccion_transferencia: "",
          button: true,
        },
      ];
      this.deposito = [
        {
          cantidad_deposito: "",
          transaccion_deposito: "",
          button: true,
        },
      ];
      this.cheque = [
        {
          cantidad_cheque: "",
          transaccion_cheque: "",
          button: true,
        },
      ];
      this.tarjeta = [
        {
          cantidad_tarjeta: "",
          transaccion_tarjeta: "",
          button: true,
        },
      ];
      this.checkMoney = {
        efectivo: false,
        transferencia: false,
        deposito: false,
        cheque: false,
        tarjeta: false,
      };
      this.checkSelect = {
        efectivo: false,
        deposito: false,
        cheque: false,
        transferencia: false,
        tarjeta: false,
      };
      this.montoFinal = {
        cantidad: 0,
        metodo: "",
        transaccion: "",
      };
      this.montos = {
        monto_efectivo: "",
        monto_transferencia: [],
        monto_deposito: [],
        monto_cheque: [],
        monto_tarjeta: [],
      };
    },
    cambiarTitulo(cliente, tipo) {
      if (tipo == 1) {
        if (cliente) {
          document.title = "Nueva venta | " + cliente.nombre;
        } else {
          document.title = "Nueva venta | Zona Auto";
        }
      } else {
        if (cliente != "") {
          document.title = "Nueva venta | " + cliente;
        } else {
          document.title = "Nueva venta | Zona Auto";
        }
      }
    },
    checkboxChange(action) {
      this.$v.$reset();
      if (action == "efectivo" && !this.checkMoney.efectivo) {
        this.cantidad_efectivo = "";
        this.sumarCantidades();
      }

      if (action == "transferencia" && !this.checkMoney.transferencia) {
        this.transferencia = [
          {
            cantidad_transferencia: "",
            transaccion_transferencia: "",
            button: true,
          },
        ];
        this.sumarCantidades();
      }
      if (action == "deposito" && !this.checkMoney.deposito) {
        this.deposito = [
          {
            cantidad_deposito: "",
            transaccion_deposito: "",
            button: true,
          },
        ];
        this.sumarCantidades();
      }

      if (action == "cheque" && !this.checkMoney.cheque) {
        this.cheque = [
          {
            cantidad_cheque: "",
            transaccion_cheque: "",
            button: true,
          },
        ];
        this.sumarCantidades();
      }
      if (action == "tarjeta" && !this.checkMoney.tarjeta) {
        this.cheque = [
          {
            cantidad_tarjeta: "",
            transaccion_tarjeta: "",
            button: true,
          },
        ];
        this.sumarCantidades();
      }
    },
    sumarCantidades() {
      let sum = 0;
      let sum2 = 0;
      let sum3 = 0;
      let sum4 = 0;
      let sum5 = 0;

      if (this.checkMoney.efectivo) {
        sum =
          parseFloat(this.converMaskToNumberxd(this.cantidad_efectivo)) > 0
            ? parseFloat(this.converMaskToNumberxd(this.cantidad_efectivo))
            : 0;
        // this.validarCantidades.efectivo = sum;
      }

      if (this.checkMoney.transferencia) {
        for (let i = 0; i < this.transferencia.length; i++) {
          sum2 =
            sum2 +
            (parseFloat(
              this.converMaskToNumberxd(
                this.transferencia[i].cantidad_transferencia
              )
            ) > 0
              ? parseFloat(
                  this.converMaskToNumberxd(
                    this.transferencia[i].cantidad_transferencia
                  )
                )
              : 0);
        }
      }

      if (this.checkMoney.deposito) {
        for (let i = 0; i < this.deposito.length; i++) {
          sum3 =
            sum3 +
            (parseFloat(
              this.converMaskToNumberxd(this.deposito[i].cantidad_deposito)
            ) > 0
              ? parseFloat(
                  this.converMaskToNumberxd(this.deposito[i].cantidad_deposito)
                )
              : 0);
        }
      }

      if (this.checkMoney.cheque) {
        for (let i = 0; i < this.cheque.length; i++) {
          sum4 =
            sum4 +
            (parseFloat(
              this.converMaskToNumberxd(this.cheque[i].cantidad_cheque)
            ) > 0
              ? parseFloat(
                  this.converMaskToNumberxd(this.cheque[i].cantidad_cheque)
                )
              : 0);
        }
      }

      if (this.checkMoney.tarjeta) {
        for (let i = 0; i < this.tarjeta.length; i++) {
          sum5 =
            sum5 +
            (parseFloat(
              this.converMaskToNumberxd(this.tarjeta[i].cantidad_tarjeta)
            ) > 0
              ? parseFloat(
                  this.converMaskToNumberxd(this.tarjeta[i].cantidad_tarjeta)
                )
              : 0);
        }
      }

      this.montoFinal.cantidad = sum + sum2 + sum3 + sum4 + sum5;

      // if (accion == 1) {
      //   this.montoFinal.cantidad = parseFloat(
      //     this.converMaskToNumberxd(cantidad)
      //   );
      // } else {
      //   this.montoFinal.transaccion = cantidad;
      // }
    },
    onButton(action, index) {
      if (action == "transferencia-plus") {
        this.transferencia.push({
          transaccion_transferencia: "",
          cantidad_transferencia: "",
          button: false,
        });
      }
      if (action == "transferencia-minus") {
        this.transferencia.splice(index, 1);
        this.sumarCantidades();
      }
      if (action == "deposito-plus") {
        this.deposito.push({
          transaccion_deposito: "",
          cantidad_deposito: "",
          button: false,
        });
      }
      if (action == "deposito-minus") {
        this.deposito.splice(index, 1);
        this.sumarCantidades();
      }
      if (action == "cheque-plus") {
        this.cheque.push({
          transaccion_cheque: "",
          cantidad_cheque: "",
          button: false,
        });
      }
      if (action == "cheque-minus") {
        this.cheque.splice(index, 1);
        this.sumarCantidades();
      }

      if (action == "tarjeta-plus") {
        this.tarjeta.push({
          transaccion_tarjeta: "",
          cantidad_tarjeta: "",
          button: false,
        });
      }
      if (action == "tarjeta-minus") {
        this.tarjeta.splice(index, 1);
        this.sumarCantidades();
      }
    },
    asignarPorcentaje() {
      if (parseFloat(this.converMaskToNumberxd(this.porcentaje)) == 0) {
        // Asignar porcentaje
        this.arrayDetalle[this.indexPorcentaje].porcentaje_venta = parseFloat(
          this.converMaskToNumberxd(this.porcentaje)
        );
        // Asignar precio original
        // this.arrayDetalle[this.indexPorcentaje].precio_original = parseFloat(
        //   this.precioOriginal
        // );
        this.arrayDetalle[this.indexPorcentaje].precio_venta = parseFloat(
          this.precioDescuento
        );
        this.arrayDetalle[this.indexPorcentaje].subtotal =
          (this.arrayDetalle[this.indexPorcentaje].cantidad != ""
            ? this.arrayDetalle[this.indexPorcentaje].cantidad
            : 0.0) *
          (this.arrayDetalle[this.indexPorcentaje].precio_venta != ""
            ? this.arrayDetalle[this.indexPorcentaje].precio_venta
            : 0.0);
        this.$refs["modalPorcentaje"].hide();
        return;
      }

      if (
        parseFloat(this.converMaskToNumberxd(this.porcentaje)) >= 5 &&
        parseFloat(this.converMaskToNumberxd(this.porcentaje)) <= 23
      ) {
        // Asignar porcentaje
        this.arrayDetalle[this.indexPorcentaje].porcentaje_venta = parseFloat(
          this.converMaskToNumberxd(this.porcentaje)
        );
        // Asignar precio original
        // this.arrayDetalle[this.indexPorcentaje].precio_original = parseFloat(
        //   this.precioOriginal
        // );
        this.arrayDetalle[this.indexPorcentaje].precio_venta = parseFloat(
          this.precioDescuento
        );
        this.arrayDetalle[this.indexPorcentaje].subtotal =
          (this.arrayDetalle[this.indexPorcentaje].cantidad != ""
            ? this.arrayDetalle[this.indexPorcentaje].cantidad
            : 0.0) *
          (this.arrayDetalle[this.indexPorcentaje].precio_venta != ""
            ? this.arrayDetalle[this.indexPorcentaje].precio_venta
            : 0.0);
        this.$refs["modalPorcentaje"].hide();
      } else {
        Vue.toasted.error(
          "El porcentaje de descuento debe estar en el rango 5% - 23%",
          this.options
        );
      }
    },
    asignarIndex(data) {
      this.indexPorcentaje = data;
      if (this.arrayDetalle[data].porcentaje_venta > 0) {
        this.porcentaje = this.arrayDetalle[data].porcentaje_venta.toString();
        this.precioOriginal = this.arrayDetalle[data].precio_original;
        this.precioDescuento = this.arrayDetalle[data].precio_venta;
      } else {
        this.porcentaje = "";
        this.precioOriginal = this.arrayDetalle[data].precio_original;
        this.precioDescuento = "";
      }
    },
    validarExistencia(data) {
      axios
        .get(
          process.env.VUE_APP_URL +
            "productos/existencia_actual?id=" +
            data.item.id2 +
            "&tipo=0",
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then((response) => {
          // console.log(data.item.cantidad, response);
          const existencia = response.data.existencia_disponible;
          if (data.item.cantidad > existencia) {
            // console.log("sobrepasa", existencia);
            Vue.toasted.error(
              `La existencia del producto < ${data.item.producto} > es de ${existencia} unidades`,
              this.options
            );
            if (existencia > 1) {
              // console.log("a");
              data.item.cantidad = 1;
            } else {
              // console.log("b");
              data.item.cantidad = 0;
            }
          }
        });
    },
    cambiarTipo(tipo, numero) {
      if (numero == 1) {
        this.busquedaLabel = tipo;
      } else {
        this.busquedaLabel2 = tipo;
      }
    },
    swCliente() {
      // console.log(this.formPro.cliente);
      this.formPro.cliente = null;
      document.title = "Nueva venta | Zona Auto";
    },
    // NUEVAS MODIFICACIONES
    async selectOpc() {
      let me = this;
      // console.log(me.ubicacionModel);
      this.arrayEstante = [];
      try {
        const response = await axios.get(
          process.env.VUE_APP_URL +
            "departamentos/estante/busqueda?departamento=" +
            me.ubicacionModel.id,
          {
            headers: { "x-token": this.userT.token },
          }
        );
        me.arrayEstante = response.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    cambioApiBase() {
      this.apiBase =
        process.env.VUE_APP_URL +
        "productos/nuevo_get?departamento=" +
        this.ubicacionModel.id +
        "&estante=" +
        this.estanteModel.id;
    },
    // fin nuevas modificaciones
  
    //AL ABRIR EL MODAL RESETEAR LAS VALIDACIONES Y VARIABLES
    openModal(model) {
      switch (model) {
        case "save": {
          this.$v.formCliente.$reset();
          this.limpiarVariables();
          // console.log("entrando a resetear")
          break;
        }
        case "update": {
          this.$v.$reset();
          break;
        }
        case "productos": {
          this.arrayProductos = [];
          this.producto = "";
          // this.focus(1);
          break;
        }
        case "servicios": {
          this.arrayServicios = [];
          this.servicio = "";
          break;
        }
        case "porcentaje": {
          this.indexPorcentaje = 0;
          this.precioOriginal = "";
          this.precioDescuento = "";
          break;
        }
        case "credito": {
          if (this.formCredito.asignado == false) {
            this.resetCredito();
          }
          break;
        }
      }
    },
    //Variables que necesitan ser limpiadas para los modales
    limpiarVariables() {
      // this.switchCliente = false;
      this.formCliente.id = 0;
      this.formCliente.telefono = "";
      this.formCliente.nombre = "";
      this.formCliente.nit = "C/F";
      this.formCliente.direccion = "";
    },
    limpiarTodo() {
      this.limpiarVariables();
      this.formPro;
      this.formPro = {
        fecha_compra: new Date(),
        tiendaid: "",
        observaciones: "",
        tienda: "",
        cliente: null,
        total: "",
        total_servicios: "",
        total_productos: "",
        state: true,
        id: 0,
      };
      this.gettienda();
      this.porcentaje = "";
      this.indexPorcentaje = "";
      this.precioOriginal = "";
      this.precioDescuento = "";
      this.arrayProductos = [];
      this.producto = "";
      this.arrayServicios = [];
      this.servicio = "";
      this.arrayDetalle = [];
      this.arrayDetalleServicio = [];
      this.search = "";
      this.search2 = "";
    },
    //Cuanso se cierre el modal por cualquier motivo, cerrar los modadles y en actualizar parar loading
    closeModal(model) {
      switch (model) {
        case "save": {
          this.showModalNP = false;
          this.showmodalL = false;
          break;
        }
        case "update": {
          this.showModalE = false;
          this.showmodalL = false;
          break;
        }
      }
    },
    //Para abrir los modales y pasar los datos de la fila o limpiar valores
    onActionClicked(action) {
      if (action == "new-item") {
        this.limpiarVariables();
      }
    },
    async selectClientes(search, loading) {
      let me = this;
      loading(true);
      let url = this.apiUrl + "clientes/busqueda?search=" + search;
      try {
        const response = await axios.get(url, {
            headers: { "x-token": this.userT.token },
          });
        let respuesta = response.data;
        // a: search;
        me.arrayClientes = respuesta;
        loading(false);
      } catch (err) {
        console.log(err);
      }
    },
    getDatosCliente(val1) {
      let me = this;
      me.loading = true;
      if (val1 == null || val1 == "") {
        me.formPro.cliente = "";
        me.idCliente = -1;
      } else {
        me.idCliente = val1.id;
      }
    },
    async gettienda() {
      let me = this;
      me.formPro.tiendaid = "";
      me.formPro.tienda = "";

      axios
        .get(process.env.VUE_APP_URL + "tiendas/selectById?id="+this.userT.tienda, {
          headers: { "x-token": this.userT.token },
        })
        .then(function (response) {
          console.log(response);
          me.formPro.tienda = response.data.data.nombre_tienda;
          me.formPro.tiendaid = response.data.data.id;
         
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {
        //   this.getDepartamento();
        });
    },
    tomandototal() {
      let temp = parseFloat(this.calcularTotal);
      let temp2 = parseFloat(this.calcularProductos);
      let temp3 = parseFloat(this.calcularServicios);
      this.formPro.total = temp;
      this.formPro.total_productos = temp2;
      this.formPro.total_servicios = temp3;
    },
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    //Validaciones antes de guardar
    validaciones(opc) {
      // stop here if form is invalid
      // console.log(this.formPro.cliente);
      this.formPro.tienda = this.userT.tienda;
      this.$v.$touch();

        if (
          this.arrayDetalle.length > 0 &&
          this.arrayDetalleServicio.length == 0
        ) {
          if (this.$v.arrayDetalle.$error) {
            Vue.toasted.error("Complete los campos de productos", this.options);
          } else {
            this.showModalL = true;
            if (opc == "save") {
            //   console.log("guarda");
              this.save();
            }
          }
        }else{
                    if (
                this.arrayDetalle.length == 0 &&
                this.arrayDetalleServicio.length == 0 && this.selectedOption != 'REPARACIÓN'  && this.selectedOption != 'TERMINADO'
                ){
                    this.save();
                }
                if(this.selectedOption == 'REPARACIÓN'  || this.selectedOption == 'TERMINADO' || this.selectedOption == 'DIAGNOSTICO'  ){
                    if(this.arrayDetalle.length == 0 && this.arrayDetalleServicio.length == 0){
                        Vue.toasted.error("Debes agregar productos y servicios", this.options);
                    }else{
                        if (
                    this.arrayDetalleServicio.length > 0 &&
                    this.arrayDetalle.length > 0
                    ) {
                    if (
                        this.$v.arrayDetalle.$error ||
                        this.$v.arrayDetalleServicio.$error
                    ) {
                        Vue.toasted.error(
                        "Complete los campos de productos y servicios",
                        this.options
                        );
                    } else {
                        this.showModalL = true;
                        if (opc == "save") {
                        this.save();
                        }
                    }
                    }
                    }
                }
        }

        if (
          this.arrayDetalleServicio.length > 0 &&
          this.arrayDetalle.length == 0
        ) {
          if (this.$v.arrayDetalleServicio.$error) {
            Vue.toasted.error("Complete los campos de servicios", this.options);
          } else {
            this.showModalL = true;
            if (opc == "save") {
              // console.log("guarda");
              this.save();
            }
          }
        

        if (
          this.arrayDetalleServicio.length > 0 &&
          this.arrayDetalle.length > 0
        ) {
          if (
            this.$v.arrayDetalle.$error ||
            this.$v.arrayDetalleServicio.$error
          ) {
            Vue.toasted.error(
              "Complete los campos de productos y servicios",
              this.options
            );
          } else {
            this.showModalL = true;
            if (opc == "save") {
              // console.log("guarda");
              this.save();
            }
          }
        }

      }
    },
    swNit() {
      if (!this.toggleNit) {
        this.formCliente.nit = "C/F";
      }
      // else {
      //   this.formCliente.nit = "";
      // }
    },
    validacionesCliente(opc) {
      // stop here if form is invalid
      this.$v.formCliente.nombre.$touch();
      // this.$v.formCliente.telefono_cliente.$touch();
      // let telC = 0;
      let { nombre } = this.formCliente;

      // for (let i = 0; i < telefono_cliente.length; i++) {
      //   if (telefono_cliente[i] == "_" || telefono_cliente[i] == "") {
      //     telC++;
      //   }
      // }

      if (nombre != "") {
        this.showModalL = true;
        if (opc == "save") {
          // console.log("cliente", this.formCliente);
          this.saveCliente();
        }
        if (opc == "update") {
          this.update();
        }
      } else {
        Vue.toasted.error("Complete los datos del cliente", this.options);
      }
    },
    //Guardar registro
    save() {
      const {  observacion_general, total } =
        this.formPro;
      
      
        axios
          .put(
            process.env.VUE_APP_URL + "ordenes/diagnostico",
            {
              id: this.$route.params.id,
              usuario: this.userT.id,
              observacion_general,
              productos: this.arrayDetalle,
              servicios: this.arrayDetalleServicio,
              diagnostico : this.selectedOption,
              total_productos: this.calcularProductos,
              total_servicios: this.calcularServicios,
              total,
              // Creditos
            },
            {
              headers: { "x-token": this.userT.token },
            }
          )
          .then((response) => {
            Vue.toasted.success("Diagnostico guardado", this.optionsFast);
            this.limpiarTodo();
            this.showModalL = false;
            this.$router.push({
              name: "taller",
              params: { id: response.data.id },
            });
          })
          .catch((error) => {
            this.errorMessage = error.message;
            console.error("Error!", error);
            Vue.toasted.error("Error para guardar", this.options);
          })
          .finally(() => {
            this.showModalL = false;
      
          });
    
    },
    saveCliente() {
      const { nombre, nit, direccion, telefono_cliente, correo, cui } =
        this.formCliente;
      const me = this;
      axios
        .post(
          process.env.VUE_APP_URL + "clientes/store",
          {
            nombre,
            nit,
            direccion,
            numero: telefono_cliente,
            email: correo,
            cui,
          },
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then((response) => {
          Vue.toasted.success(nombre + " Guardado", this.options);
          // console.log(response.data);
          me.formPro.cliente = response.data.clientes[0];
          this.formPro.cliente = {
          id: response.data.clientes[0].id,
          nombre: response.data.clientes[0].nombre,
          nit_cliente: response.data.clientes[0].nit_cliente,
          persona: response.data.clientes[0].persona,
        };
        this.idCliente = response.data.clientes[0].id;
          this.showModalN = false;
          this.showModalL = false;
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("Error!", error);
          Vue.toasted.error("Error para guardar", this.options);
        })
        .finally(() => {
          this.showModalN = false;
          this.showModalL = false;
        });
    },
    // Funciones para trabajar con detalles
    eliminarDetalle({ index }) {
      let me = this;
      me.arrayDetalle.splice(index, 1);
    },
    eliminarDetalleServicio({ index }) {
      let me = this;
      me.arrayDetalleServicio.splice(index, 1);
    },
    converMaskToNumberxd(number) {
      var myNumber = "";
      for (var i = 0; i < number.length; i += 1) {
        if (
          number.charAt(i) === "Q" ||
          number.charAt(i) === "€" ||
          number.charAt(i) === "$" ||
          number.charAt(i) === "%" ||
          number.charAt(i) === "," ||
          number.charAt(i) === " "
        ) {
          continue;
        } else {
          myNumber += number.charAt(i);
        }
      }
      return parseFloat(myNumber).toFixed(2);
    },
    // Funciones para formatos
    updateprecionuevo(data) {
      if (data.precio_venta == "") {
        data.validate1 = true;
        data.porcentaje_venta = "";
        data.subtotal =
          (data.cantidad != "" ? data.cantidad : 0.0) *
          (data.precio_venta != "" ? data.precio_venta : 0.0);
        return;
      }
      const temp = data.precio_original - data.precio_venta;
      const porcentaje = (
        (parseFloat(temp) * 100) /
        data.precio_original
      ).toFixed(2);
      if (porcentaje >= 5 && porcentaje <= 23) {
        // Vue.toasted.success(
        //     "Porcentaje asignado",
        //     this.options
        // );
        data.validate1 = false;
        data.porcentaje_venta = porcentaje;
      } else if (porcentaje == 0) {
        data.validate1 = false;
        data.porcentaje_venta = "";
      } else {
        // Vue.toasted.error(
        //     "El porcentaje de descuento debe estar en el rango 5% - 23%",
        //     this.optionsFast
        // );
        data.validate1 = true;
        // data.precio_venta = data.precio_original
        data.porcentaje_venta = "";
      }
      if (!data.validate1) {
        data.subtotal =
          (data.cantidad != "" ? data.cantidad : 0.0) *
          (data.precio_venta != "" ? data.precio_venta : 0.0);
      } else {
        data.subtotal = 0.0;
        this.$refs.table.refresh();
      }
      // console.log('data', porcentaje);
    },
    updateporcentaje(data) {
      // const me = this;
      if (data.porcentaje_venta == "") {
        data.validate1 = false;
        data.precio_venta = data.precio_original;
        data.subtotal =
          (data.cantidad != "" ? data.cantidad : 0.0) *
          (data.precio_venta != "" ? data.precio_venta : 0.0);
        return;
      }

      setTimeout(() => {
        if (data.porcentaje_venta < 5 || data.porcentaje_venta > 23) {
          data.validate1 = true;
          data.porcentaje_venta = "";
          if (data.dropdownTipo === 1) {
            data.precio_venta = data.tipos_precio[0].cantidad;
            data.subtotal =
              (data.cantidad != "" ? data.cantidad : 0.0) *
              (data.precio_venta != "" ? data.precio_venta : 0.0);
          }
          if (data.dropdownTipo === 2) {
            data.precio_venta = data.tipos_precio[1].cantidad;
            data.subtotal =
              (data.cantidad != "" ? data.cantidad : 0.0) *
              (data.precio_venta != "" ? data.precio_venta : 0.0);
          }
          if (data.dropdownTipo === 3) {
            data.precio_venta = data.tipos_precio[2].cantidad;
            data.subtotal =
              (data.cantidad != "" ? data.cantidad : 0.0) *
              (data.precio_venta != "" ? data.precio_venta : 0.0);
          }
          return;
        }

        data.validate1 = false;
        data.precio_venta = (
          parseFloat(data.precio_original) -
          (parseFloat(data.porcentaje_venta) / 100) *
            parseFloat(data.precio_original)
        ).toFixed(2);

        if (!data.validate1) {
          data.subtotal =
            (data.cantidad != "" ? data.cantidad : 0.0) *
            (data.precio_venta != "" ? data.precio_venta : 0.0);
        } else {
          data.subtotal = 0.0;
          this.$refs.table.refresh();
        }
      }, 700);

      // this.$refs.table.refresh();
    },
    updateDisableDates({ index }) {
      const me = this;
      me.arrayDetalle[index].subtotal =
        (me.arrayDetalle[index].cantidad != ""
          ? me.arrayDetalle[index].cantidad
          : 0.0) *
        (me.arrayDetalle[index].precio_venta != ""
          ? me.arrayDetalle[index].precio_venta
          : 0.0);
      this.$refs.table.refresh();

      // item.no_extras = 0;
    },
    sumarCantidadServicio({ index }) {
      const me = this;
      // console.log(item);
      me.arrayDetalleServicio[index].subtotal =
        (me.arrayDetalleServicio[index].cantidad != ""
          ? me.arrayDetalleServicio[index].cantidad
          : 0.0) *
        (me.arrayDetalleServicio[index].precio_venta != ""
          ? me.arrayDetalleServicio[index].precio_venta
          : 0.0);
      this.$refs.table2.refresh();

      // item.no_extras = 0;
    },
    cambiarPrecioProducto(tipo, data) {
      // console.log(tipo, data, this.arrayDetalle[data.index]);
      this.arrayDetalle[data.index].precio_original = tipo.cantidad;
      this.arrayDetalle[data.index].precio_venta =
        this.arrayDetalle[data.index].porcentaje_venta >= 5 &&
        this.arrayDetalle[data.index].porcentaje_venta <= 23
          ? (
              parseFloat(tipo.cantidad) -
              (this.arrayDetalle[data.index].porcentaje_venta / 100) *
                parseFloat(tipo.cantidad)
            ).toFixed(2)
          : parseFloat(tipo.cantidad);
      // this.arrayDetalle[data.index].porcentaje_venta = 0;
      this.arrayDetalle[data.index].dropdownLabel = tipo.nombre;
      this.arrayDetalle[data.index].dropdownTipo = tipo.tipo;
      this.arrayDetalle[data.index].subtotal =
        this.arrayDetalle[data.index].cantidad *
        this.arrayDetalle[data.index].precio_venta;
    },
    formatQuetzales(amount) {
      let num = parseFloat(amount),
        formatted;
      formatted = num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
      return (amount = "Q " + formatted);
    },
    // FUNCIONES AUXILIARES
    money(value) {
      return (
        "Q " +
        parseFloat(value)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    showDate(date) {
      return moment(date).locale("es").utc().format("MMM Do YYYY");
    },
    trasladoDetalle() {
      const me = this;
      axios
        .get(
          process.env.VUE_APP_URL +
            "productos/stock/busqueda_compras?departamento=" +
            this.ubicacionModel.id +
            "&estante=" +
            this.estanteModel.id +
            "&activador=" +
            this.activa_cliente +
            "&cliente=" +
            this.formPro.cliente.id,
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then((response) => {
          this.arrayDet = response.data.data;
        })
        .catch((response) => {
          console.log(response);
        })
        .finally(() => {
          for (let i = 0; i < this.arrayDet.length; i++) {
            if (this.traslado_masivo == true) {
              if (this.encuentra(this.arrayDet[i].Stock.id)) continue;
              me.arrayDetalle.push({
                precio_compra: this.arrayDet[i].Stock.precio_compra_stock,
                precio_venta: this.arrayDet[i].Stock.precio_venta_stock,
                presentacionId: this.arrayDet[i].Stock.presentacioneId,
                presentacion:
                  this.arrayDet[i].Stock.presentacione.nombre_presentacion,
                id: this.arrayDet[i].Stock.id,
                ubicacion: this.arrayDet[i].departamentoId,
                producto: this.arrayDet[i].Stock.producto.nombre_producto,
                cantidad: "",
                subtotal: 0,
              });
            } else {
              me.arrayDetalle.splice(me.arrayDetalle.length - 1);
            }
          }
        });
    },
    cambiarCantidadPrecio(data) {
      // console.log(parseInt(data.item.cantidad),parseInt(data.item.existencia_actual))
      let temporal = 0;
      if(parseInt(data.item.cantidad)>parseInt(data.item.existencia_actual)){
        // console.log('esta entrando');
        this.arrayDetalle[data.index].cantidad = parseInt(data.item.existencia_actual);
        // console.log( this.arrayDetalle[data.index].cantidad,parseInt(data.item.existencia_actual) )
      }
      else if(parseInt(data.item.cantidad)<=0){
        // console.log('esta entrando al else if');
        this.arrayDetalle[data.index].cantidad = 1;
      }
  
        temporal =
          parseFloat(this.arrayDetalle[data.index].precio_venta) *
          parseFloat(this.arrayDetalle[data.index].cantidad);
        // console.log('entro al normal')
      
      this.arrayDetalle[data.index].subtotal = temporal.toFixed(2);
      this.$refs.table.refresh();
    },
    agregarDetalle(data) {
      const me = this;
      // console.log(data)
     if(data.existencia_stock <=0){
        Vue.toasted.error("Producto sin existencia en tienda");
        return;
     }
          me.arrayDetalle.push({
            id : data.producto.id,
            inventarioProductoId : data.id,
            precio_compra: data.producto.precio_compra,
            precio_venta: data.producto.precio_venta,
            precio_original: data.producto.precio_venta,
            validate1: false,
            validate2: false,
         
            codigo: data.producto.codigo_stock,
            departamento: data.bodega.nombre_bodega,
     
            producto: data.producto.nombre_producto,
            imagen_stock: data.producto.imagen_stock,
            cantidad: 1,
            existencia_actual: data.existencia,
         
            subtotal: data.producto.precio_venta,
          });
          this.producto = null;
          this.resetCredito();
   
      // console.log(me.arrayDetalle);
    },
    agregarDetalleServicio(data) {
      // console.log(data);
      this.arrayDetalleServicio.push({
        nombre_servicio: data.nombre_servicio,
        descripcion_servicio: data.descripcion_servicio,
        cantidad: 1,
        subtotal: 0,
        precio_venta: 0,
        id: data.id,
      });
      this.resetCredito();
      // console.log(this.arrayDetalleServicio);
    },
    verificarstock(stock) {
      const me = this;
      // console.log(stock, 'estock');
      if (me.encuentra(stock.id)) {
        return true;
      }
    },
    verificarServicio(stock) {
      const me = this;
      // console.log(stock)
      if (me.encuentra2(stock["id"].toString())) {
        return true;
      }
    },
    // Esta función encuentra si en el detatalle ya esta la habitacion
    encuentra(id) {
      let sw = 0;
      for (var i = 0; i < this.arrayDetalle.length; i++) {
        if (this.arrayDetalle[i].id == id) {
          sw = true;
        }
      }
      return sw;
    },
    encuentra2(id) {
      let sw = 0;
      for (var i = 0; i < this.arrayDetalleServicio.length; i++) {
        if (this.arrayDetalleServicio[i].id.toString() == id) {
          sw = true;
        }
      }
      return sw;
    },
    async getClientes() {
      this.arrayClientes = [];
      try {
        const response = await axios.get(
          process.env.VUE_APP_URL + "clientes/busqueda",
          {
            headers: { "x-token": this.userT.token },
          }
        );
        this.arrayClientes = response.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getProductos(producto) {
      this.arrayProductos = [];
      const tienda = this.userT.tienda;
      if (producto == "" || producto == " ") {
        this.arrayProductos = [];
        return;
      } else {
        try {
          const response = await axios.get(
            process.env.VUE_APP_URL +
              `productos/get/busqueda?criterio=${this.busquedaLabel.value}&search=${producto}&tienda=${tienda}`,
            {
              headers: { "x-token": this.userT.token },
            }
          );
          this.arrayProductos = response.data.data;
        //   console.log(this.arrayProductos);
        } catch (error) {
          console.log(error);
        }
      }
    },
    async getServicios(servicio) {
      this.arrayServicios = [];
      if (servicio == "" || servicio == " ") {
        return;
      } else {
        const response = await axios.get(
          process.env.VUE_APP_URL + `servicios/select?search=${servicio}`,
          {
            headers: { "x-token": this.userT.token },
          }
        );
        this.arrayServicios = response.data.data;
      }
    },
   

    //Buscador dentro de la tabala
    onFiltered() {
      this.search = this.search.toLowerCase();
      this.$refs.vuetable.refresh();
    },
    onFiltered2() {
      this.search2 = this.search2.toLowerCase();
      this.$refs.vuetable2.refresh();
    },
    //enviar datos a la Paginacion
    onPaginationData(paginationData) {
      this.to = paginationData.to;
      this.total = paginationData.total;
      this.lastPage = paginationData.last_page;
      // this.items = paginationData.data;
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onPaginationData2(paginationData) {
      this.to2 = paginationData.to;
      this.total2 = paginationData.total;
      this.lastPage2 = paginationData.last_page;
      // this.items = paginationData.data;
      this.$refs.pagination2.setPaginationData(paginationData);
    },
    //Cambiar tamaño de filas en la tabala para mostrar
    changePageSize() {
      this.$refs.vuetable.refresh();
    },
    changePageSize2() {
      this.$refs.vuetable2.refresh();
    },

    // Cambiar el valor del dropwdown para poder filtrar
    changeTypeSearch(type) {
      this.searchLabel = type;
      this.$refs.vuetable.refresh();
    },
    changeTypeSearch2(type) {
      this.searchLabel2 = type;
      this.$refs.vuetable2.refresh();
    },
    //Cuando cambia de pagina
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },

    onChangePage2(page) {
      this.$refs.vuetable2.changePage(page);
    },
    //Query para realizar busquedas y ordenar
    makeQueryParams(sortOrder, currentPage) {
      return sortOrder[0]
        ? {
            criterio: sortOrder[0]
              ? sortOrder[0].sortField
              : this.searchLabel.value,

            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
          }
        : {
            criterio: sortOrder[0]
              ? sortOrder[0].sortField
              : this.searchLabel.value,

            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
          };
    },
    makeQueryParams2(sortOrder, currentPage) {
      return sortOrder[0]
        ? {
            criterio: sortOrder[0] ? sortOrder[0].sortField : "nombre_persona",
            categoria: this.searchLabel2.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search2,
          }
        : {
            criterio: sortOrder[0] ? sortOrder[0].sortField : "nombre_persona",
            categoria: this.searchLabel2.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search2,
          };
    },
    updateSelectedOption(option) {
        console.log(option);
      this.selectedOption = option;
    }
  },
};
</script>

<template>
  <Layout>
    <!-- Modal de Nuevo Cliente-->
    <b-modal
      centered
      @show="openModal('save')"
      @hidden="openModal('save')"
      v-model="showModalN"
      id="modalCliente"
      ref="modalCliente"
      title="Nuevo cliente"
      title-class="text-black font-18"
      body-class="p-3"
      hide-footer
      no-close-on-backdrop
    >
      <form>
        <!-- Nombre -->
        <div class="col-12">
          <div class="mb-3">
            <label for="name">Nombre</label>
            <input
              id="name"
              v-model="$v.formCliente.nombre.$model"
              type="text"
              class="form-control"
              placeholder="Ingrese un nombre"
              :class="{
                'is-invalid': $v.formCliente.nombre.$error,
              }"
              @input="$v.formCliente.nombre.$touch()"
            />
            <div
              v-if="
                $v.formCliente.nombre.$error && !$v.formCliente.nombre.required
              "
              class="invalid-feedback"
            >
              El nombre es obligatorio.
            </div>
          </div>
        </div>
        <!-- Identificacion -->
        <div class="col-12">
          <div class="mb-3">
            <label for="phone">Identificación</label>
            <masked-input
              v-model.trim="formCliente.cui"
              :mask="[
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                ' ',
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                ' ',
                /\d/,
                /\d/,
                /\d/,
                /\d/,
              ]"
              class="form-control"
              placeholder="Ingrese CUI"
            />
          </div>
        </div>
        <!-- Nit -->
        <div class="col-12">
          <div class="mb-3">
            <label>Nit</label>
            <input
              v-model.trim="$v.formCliente.nit.$model"
              type="text"
              class="form-control"
              placeholder="Ingrese NIT"
            />
            <div class="alert alert-danger" v-if="!$v.formCliente.nit.nit">
              El número de NIT no es valido.
            </div>
          </div>
        </div>
        <!-- Telefono -->
        <div class="col-12">
          <div class="mb-3">
            <label for="name">Teléfono</label>
            <masked-input
              v-model.trim="formCliente.telefono_cliente"
              :mask="[/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
              class="form-control"
              placeholder="Ingrese el número de teléfono"
            />
          </div>
        </div>
        <!-- Direccion -->
        <div class="col-12">
          <div class="mb-3">
            <label for="phone">Dirección del contacto</label>
            <input
              id="phone"
              v-model.trim="$v.formCliente.direccion.$model"
              type="text"
              class="form-control"
              placeholder="Ingrese Dirección"
            />
          </div>
        </div>
        <!-- Correo -->
        <div class="col-12">
          <div class="mb-3">
            <label for="correo">Correo</label>
            <input
              id="correo"
              v-model.trim="formCliente.correo"
              type="email"
              class="form-control"
              placeholder="Ingrese Correo"
            />
            <div
              class="alert alert-danger"
              v-if="!$v.formCliente.correo.correo"
            >
              El correo es inválido
            </div>
          </div>
        </div>
        <!-- Botones -->
        <div class="text-end pt-5 mt-3">
          <b-button variant="light" @click="showModalN = false"
            >Cerrar
          </b-button>
          <b-button
            @click="validacionesCliente('save')"
            variant="success"
            class="ms-1"
            >Guardar
          </b-button>
        </div>
      </form>
    </b-modal>

    <!-- Modal productos -->
    <b-modal
      centered
      @show="openModal('productos')"
      @hidden="openModal('productos')"
      id="modalProductos"
      ref="modalProductos"
      title="Productos"
      size="lg"
      title-class="text-black font-18"
      body-class="p-3"
    >
      <b-form-group>
        <b-input-group>
          <b-dropdown variant="secondary" size="sm">
            <template v-slot:button-content>
              {{ busquedaLabel.nombre }}
              <i class="mdi mdi-chevron-down"></i>
            </template>
            <b-dropdown-item
              v-for="(search, index) in busquedaTipos"
              :key="index"
              @click="cambiarTipo(search, 1)"
              >{{ search.nombre }}
            </b-dropdown-item>
          </b-dropdown>
          <b-input
            ref="inputProductos"
            v-model="producto"
            placeholder="Ingrese el código o nombre del producto"
            @input="getProductos(producto)"
          >
          </b-input>
        </b-input-group>
      </b-form-group>

      <b-table striped :items="arrayProductos" :fields="fieldsProductos">
        <template #cell(action)="data">
          <b-button
            v-if="verificarstock(data.item.producto) != true"
            @click="agregarDetalle(data.item)"
            variant="outline-primary"
            ><i class="bx bx-plus-medical"></i
          ></b-button>
        </template>
        <template #cell(producto)="data">
          <a
            :href="
              apiUrl + 'productos/get/imagen/' + data.item.producto.imagen_stock
            "
            target="_blank"
          >
            {{ data.item.producto.nombre_producto }}
          </a>
        </template>

        <template #cell(codigo)="data">
          {{ data.item.producto.codigo_stock }}
        </template>
        <template #cell(existencia)="data">
          {{ data.item.existencia }}
        </template>
        <template #cell(departamento)="data">
          {{ data.item.bodega.nombre_bodega }}
        </template>
        <template #cell(precio_venta)="data">
          {{ money(data.item.producto.precio_venta) }}
        </template>
      </b-table>

      <template #modal-footer="{}">
        <b-button variant="danger" @click="$bvModal.hide('modalProductos')"
          >Cerrar
        </b-button>
      </template>
    </b-modal>

    <!-- Modal servicios -->
    <b-modal
      centered
      @show="openModal('servicios')"
      @hidden="openModal('servicios')"
      id="modalServicios"
      ref="modalServicios"
      title="Servicios"
      size="lg"
      title-class="text-black font-18"
      body-class="p-3"
    >
      <b-input
        ref="inputServicios"
        v-model="servicio"
        placeholder="Ingrese el nombre del servicio"
        @input="getServicios(servicio)"
      >
      </b-input>
      <b-table striped :items="arrayServicios" :fields="fieldsServicios">
        <template #cell(action)="data">
          <b-button
            v-if="verificarServicio(data.item) != true"
            @click="agregarDetalleServicio(data.item)"
            variant="outline-primary"
            ><i class="bx bx-plus-medical"></i
          ></b-button>
        </template>
      </b-table>

      <template #modal-footer="{}">
        <b-button variant="danger" @click="$bvModal.hide('modalServicios')"
          >Cerrar
        </b-button>
      </template>
    </b-modal>

    <!-- Modal porcentaje -->
    <b-modal
      centered
      @hidden="openModal('porcentaje')"
      id="modalPorcentaje"
      ref="modalPorcentaje"
      title="Asigar porcentaje de descuento"
      title-class="text-black font-18"
      body-class="p-3"
      no-close-on-backdrop
    >
      <div v-if="arrayDetalle.length > 0">
        <h3>Precio normal</h3>
        <h5>{{ money(precioOriginal) }}</h5>
        <br />
        <h3>Nuevo precio</h3>
        <b-input
          v-model="precioDescuento"
          type="number"
          placeholder="Ingrese el precio de descuento"
          @input="updateprecionuevo()"
        />
        <br />
        <h3>Descuento</h3>

        <masked-input
          v-model="porcentaje"
          @input="updateporcentaje()"
          :mask="mask_porcentaje"
          class="form-control"
          placeholder="Ingrese el porcentaje de descuento"
        />
      </div>

      <template #modal-footer="{}">
        <b-button variant="primary" @click="asignarPorcentaje"
          >Asignar descuento
        </b-button>
        <b-button variant="danger" @click="$bvModal.hide('modalPorcentaje')"
          >Cerrar
        </b-button>
      </template>
    </b-modal>

    <!-- Modal credito -->
    <b-modal
      centered
      @show="openModal('credito')"
      id="modalCredito"
      ref="modalCredito"
      size="xl"
      title="Asignar crédito"
      title-class="text-black font-18"
      body-class="p-3"
      no-close-on-backdrop
    >
      <template #modal-header="{}">
        <h2>Asignar crédito</h2>
        <b-button variant="primary" @click="resetCredito">Limpiar</b-button>
      </template>
      <b-card>
        <div class="row">
          <div class="col">
            <b-card bg-variant="primary bg-soft">
              <div class="row">
                <div class="col">
                  <h5>Precio original</h5>
                  <h5>{{ money(formPro.total) }}</h5>
                </div>
                <div class="col">
                  <h5>Con adelanto</h5>
                  <h5>{{ money(formCredito.precioNuevo) }}</h5>
                </div>
              </div>
              <br />
              <label for="name">Adelanto</label>
              <b-input
                ref="inputCredito1"
                v-model.trim="formCredito.adelanto"
                @input="asignarAdelanto()"
                type="number"
                placeholder="Ingresar el monto de adelanto"
                class="form-control"
              />
              <!-- <masked-input
                v-model.trim="formCredito.adelanto"
                :mask="mask_quetzal"
                :guide="false"
                :keep-char-positions="true"
                :show-mask="true"
                type="text"
                @input="asignarAdelanto()"
                placeholder="Ingresar el monto de adelanto"
                class="form-control"
              /> -->
              <br />
              <label for="name">Cantidad de pagos</label>
              <b-input
                type="number"
                v-model="formCredito.cantidadPagos"
                placeholder="Ingrese la cantidad de pagos"
              />
              <br />
              <label for="name">Fecha inicio de pagos</label>
              <date-picker
                v-model="formCredito.fechaInicio"
                :first-day-of-week="1"
                lang="es"
              ></date-picker>
              <br /><br />
              <label for="name">Intervalo de días para pago</label>
              <b-input
                type="number"
                v-model="formCredito.intervalo"
                placeholder="Ingrese la cantidad de pagos"
              />
              <br />
              <b-button @click="validarCredito">CÁLCULAR CRÉDITO</b-button>
            </b-card>
          </div>
          <div class="col" style="max-height: 485px; overflow-y: auto">
            <b-card bg-variant="primary bg-soft">
              <h5>Distribución de pagos</h5>
              <div v-for="(pago, index) in formCredito.pagos" :key="index">
                <b-card no-body>
                  <h5 style="margin-top: 10px">
                    &nbsp;&nbsp;<span class="badge badge-pill bg-primary ms-1"
                      ><strong>{{ index + 1 }}</strong></span
                    >
                    {{
                      money(pago.monto_pago) + " | " + showDate(pago.fecha_pago)
                    }}
                  </h5>
                </b-card>
              </div>
            </b-card>
          </div>
        </div>
        <b-collapse v-model="formCredito.collapse1" visible class="mt-1">
          <b-tabs pills vertical nav-wrapper-class="col-sm-4">
            <!-- Efectivo -->
            <b-tab :disabled="checkSelect.efectivo">
              <template v-slot:title>
                <b-form-checkbox v-model="checkMoney.efectivo">
                  &nbsp;&nbsp;<span class="d-none d-sm-inline-block">
                    Efectivo</span
                  >&nbsp;
                  <i class="fas fa-money-bill"> </i>
                </b-form-checkbox>
              </template>

              <b-card bg-variant="primary bg-soft">
                <b-form-checkbox
                  v-model="checkMoney.efectivo"
                  @input="checkboxChange('efectivo')"
                  >&nbsp;&nbsp;Usar método de pago
                </b-form-checkbox>
                <br />
                <b-form-group label="MONTO">
                  <masked-input
                    :disabled="!checkMoney.efectivo"
                    v-model.trim="$v.cantidad_efectivo.$model"
                    :mask="mask_quetzal"
                    :guide="false"
                    :keep-char-positions="true"
                    :show-mask="true"
                    type="text"
                    @input="sumarCantidades()"
                    placeholder="Ingresar el monto a pagar"
                    :class="{
                      'is-invalid': $v.cantidad_efectivo.$error,
                    }"
                    class="form-control"
                  />
                  <div
                    v-if="checkMoney.efectivo"
                    :class="{
                      'invalid-feedback': true,
                      'd-block':
                        $v.cantidad_efectivo.$invalid &&
                        !$v.cantidad_efectivo.$invalid.required,
                    }"
                  >
                    Debe ingresar el monto
                  </div>
                  <!-- <div
                        v-if="validarCantidades.efectivo <= 0"
                        :class="{
                          'invalid-feedback': true,
                          'd-block':
                            $v.validarCantidades.efectivo.$error &&
                            !$v.validarCantidades.efectivo.minValue,
                        }"
                      >
                        La cantidad debe ser mayor a cero
                      </div> -->
                </b-form-group>
              </b-card>
            </b-tab>
            <!-- Transferencia -->
            <b-tab :disabled="checkSelect.transferencia">
              <template v-slot:title>
                <b-form-checkbox v-model="checkMoney.transferencia">
                  &nbsp;&nbsp;<span class="d-none d-sm-inline-block">
                    Transferencia</span
                  >&nbsp;
                  <i class="bx bx-transfer-alt"> </i>
                </b-form-checkbox>
              </template>

              <b-card bg-variant="primary bg-soft">
                <b-form-checkbox
                  v-model="checkMoney.transferencia"
                  @input="checkboxChange('transferencia')"
                >
                  &nbsp;&nbsp;Usar método de pago
                </b-form-checkbox>
                <br />
                <div v-for="(item, index) in transferencia" v-bind:key="index">
                  <b-form-group
                    :label="'NÚMERO DE TRANSACCIÓN' + ' ' + (index + 1)"
                    class="has-float-label"
                  >
                    <b-input-group>
                      <b-form-input
                        :disabled="!checkMoney.transferencia"
                        :class="{
                          'is-invalid':
                            $v.transferencia.$each.$iter[index]
                              .transaccion_transferencia.$error,
                        }"
                        v-model.trim="item.transaccion_transferencia"
                        placeholder="Ingresar en número de transacción"
                        @input="sumarCantidades()"
                      >
                      </b-form-input>
                      <b-input-group-append v-if="item.button">
                        <b-button
                          :disabled="!checkMoney.transferencia"
                          variant="primary"
                          @click="onButton('transferencia-plus')"
                          ><i :class="'bx bx-plus-medical'"
                        /></b-button>
                      </b-input-group-append>
                      <b-input-group-append v-if="!item.button">
                        <b-button
                          variant="primary"
                          @click="onButton('transferencia-minus', index)"
                          ><i :class="'bx bx-undo'"
                        /></b-button>
                      </b-input-group-append>
                    </b-input-group>
                    <div
                      v-if="checkMoney.transferencia"
                      :class="{
                        'invalid-feedback': true,
                        'd-block':
                          $v.transferencia.$each.$iter[index]
                            .transaccion_transferencia.$invalid &&
                          !$v.transferencia.$each.$iter[index]
                            .transaccion_transferencia.$invalid.required,
                      }"
                    >
                      Debe ingresar el número de transacción
                    </div>
                  </b-form-group>
                  <br />
                  <b-form-group label="MONTO">
                    <masked-input
                      :disabled="!checkMoney.transferencia"
                      v-model.trim="item.cantidad_transferencia"
                      :mask="mask_quetzal"
                      :guide="false"
                      :keep-char-positions="true"
                      :show-mask="true"
                      type="text"
                      @input="sumarCantidades()"
                      placeholder="Ingresar el monto a pagar"
                      :class="{
                        'is-invalid':
                          $v.transferencia.$each.$iter[index]
                            .cantidad_transferencia.$error,
                      }"
                      class="form-control"
                    />
                    <div
                      v-if="checkMoney.transferencia"
                      :class="{
                        'invalid-feedback': true,
                        'd-block':
                          $v.transferencia.$each.$iter[index]
                            .cantidad_transferencia.$invalid &&
                          !$v.transferencia.$each.$iter[index]
                            .cantidad_transferencia.$invalid.required,
                      }"
                    >
                      Debe ingresar el monto
                    </div>
                  </b-form-group>
                  <hr />
                </div>
              </b-card>
            </b-tab>
            <!-- Deposito -->
            <b-tab :disabled="checkSelect.deposito">
              <template v-slot:title>
                <b-form-checkbox v-model="checkMoney.deposito">
                  &nbsp;&nbsp;<span class="d-none d-sm-inline-block">
                    Deposito</span
                  >&nbsp;
                  <i class="bx bxs-downvote"> </i>
                </b-form-checkbox>
              </template>

              <b-card bg-variant="primary bg-soft">
                <b-form-checkbox
                  v-model="checkMoney.deposito"
                  @input="checkboxChange('deposito')"
                  >&nbsp;&nbsp;Usar método de pago
                </b-form-checkbox>
                <br />
                <div v-for="(item, index) in deposito" v-bind:key="index">
                  <b-form-group
                    :label="'NÚMERO DE DEPOSITO' + ' ' + (index + 1)"
                    class="has-float-label"
                  >
                    <b-input-group>
                      <b-form-input
                        :disabled="!checkMoney.deposito"
                        :class="{
                          'is-invalid':
                            $v.deposito.$each.$iter[index].transaccion_deposito
                              .$error,
                        }"
                        v-model.trim="item.transaccion_deposito"
                        placeholder="Ingresar en número deposito"
                        @input="sumarCantidades()"
                      >
                      </b-form-input>
                      <b-input-group-append v-if="item.button">
                        <b-button
                          :disabled="!checkMoney.deposito"
                          variant="primary"
                          @click="onButton('deposito-plus')"
                        >
                          <i :class="'bx bx-plus-medical'" />
                        </b-button>
                      </b-input-group-append>
                      <b-input-group-append v-if="!item.button">
                        <b-button
                          variant="primary"
                          @click="onButton('deposito-minus', index)"
                          ><i :class="'bx bx-undo'" />
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                    <div
                      v-if="checkMoney.deposito"
                      :class="{
                        'invalid-feedback': true,
                        'd-block':
                          $v.deposito.$each.$iter[index].transaccion_deposito
                            .$invalid &&
                          !$v.deposito.$each.$iter[index].transaccion_deposito
                            .$invalid.required,
                      }"
                    >
                      Debe ingresar el número de deposito
                    </div>
                  </b-form-group>
                  <br />
                  <b-form-group label="MONTO">
                    <masked-input
                      :disabled="!checkMoney.deposito"
                      v-model.trim="item.cantidad_deposito"
                      :mask="mask_quetzal"
                      :guide="false"
                      :keep-char-positions="true"
                      :show-mask="true"
                      type="text"
                      @input="sumarCantidades()"
                      placeholder="Ingresar el monto a pagar"
                      :class="{
                        'is-invalid':
                          $v.deposito.$each.$iter[index].cantidad_deposito
                            .$error,
                      }"
                      class="form-control"
                    />
                    <div
                      v-if="checkMoney.deposito"
                      :class="{
                        'invalid-feedback': true,
                        'd-block':
                          $v.deposito.$each.$iter[index].cantidad_deposito
                            .$invalid &&
                          !$v.deposito.$each.$iter[index].cantidad_deposito
                            .$invalid.required,
                      }"
                    >
                      Debe ingresar el monto
                    </div>
                  </b-form-group>
                  <hr />
                </div>
              </b-card>
            </b-tab>
            <!-- Cheque -->
            <b-tab :disabled="checkSelect.cheque">
              <template v-slot:title>
                <b-form-checkbox v-model="checkMoney.cheque">
                  &nbsp;&nbsp;<span class="d-none d-sm-inline-block">
                    Cheque</span
                  >&nbsp;
                  <i class="bx bx-dock-top"> </i>
                </b-form-checkbox>
              </template>

              <b-card bg-variant="primary bg-soft">
                <b-form-checkbox
                  v-model="checkMoney.cheque"
                  @input="checkboxChange('cheque')"
                  >&nbsp;&nbsp;Usar método de pago
                </b-form-checkbox>
                <br />
                <div v-for="(item, index) in cheque" v-bind:key="index">
                  <b-form-group
                    :label="'NÚMERO DE CHEQUE' + ' ' + (index + 1)"
                    class="has-float-label"
                  >
                    <b-input-group>
                      <b-form-input
                        :disabled="!checkMoney.cheque"
                        :class="{
                          'is-invalid':
                            $v.cheque.$each.$iter[index].transaccion_cheque
                              .$error,
                        }"
                        v-model.trim="item.transaccion_cheque"
                        placeholder="Ingresar en número dcheque"
                        @input="sumarCantidades()"
                      >
                      </b-form-input>
                      <b-input-group-append v-if="item.button">
                        <b-button
                          :disabled="!checkMoney.cheque"
                          variant="primary"
                          @click="onButton('cheque-plus')"
                          ><i :class="'bx bx-plus-medical'"
                        /></b-button>
                      </b-input-group-append>
                      <b-input-group-append v-if="!item.button">
                        <b-button
                          variant="primary"
                          @click="onButton('cheque-minus', index)"
                          ><i :class="'bx bx-undo'" />
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                    <div
                      v-if="checkMoney.cheque"
                      :class="{
                        'invalid-feedback': true,
                        'd-block':
                          $v.cheque.$each.$iter[index].transaccion_cheque
                            .$invalid &&
                          !$v.cheque.$each.$iter[index].transaccion_cheque
                            .$invalid.required,
                      }"
                    >
                      Debe ingresar el número dcheque
                    </div>
                  </b-form-group>
                  <br />
                  <b-form-group label="MONTO">
                    <masked-input
                      :disabled="!checkMoney.cheque"
                      v-model.trim="item.cantidad_cheque"
                      :mask="mask_quetzal"
                      :guide="false"
                      :keep-char-positions="true"
                      :show-mask="true"
                      type="text"
                      @input="sumarCantidades()"
                      placeholder="Ingresar el monto a pagar"
                      :class="{
                        'is-invalid':
                          $v.cheque.$each.$iter[index].cantidad_cheque.$error,
                      }"
                      class="form-control"
                    />
                    <div
                      v-if="checkMoney.cheque"
                      :class="{
                        'invalid-feedback': true,
                        'd-block':
                          $v.cheque.$each.$iter[index].cantidad_cheque
                            .$invalid &&
                          !$v.cheque.$each.$iter[index].cantidad_cheque.$invalid
                            .required,
                      }"
                    >
                      Debe ingresar el monto
                    </div>
                  </b-form-group>
                  <hr />
                </div>
              </b-card>
            </b-tab>
            <!-- Tarjeta -->
            <b-tab :disabled="checkSelect.tarjeta">
              <template v-slot:title>
                <b-form-checkbox v-model="checkMoney.tarjeta">
                  &nbsp;&nbsp;<span class="d-none d-sm-inline-block">
                    Tarjeta</span
                  >&nbsp;
                  <i class="far fa-credit-card"> </i>
                </b-form-checkbox>
              </template>

              <b-card bg-variant="primary bg-soft">
                <b-form-checkbox
                  v-model="checkMoney.tarjeta"
                  @input="checkboxChange('tarjeta')"
                  >&nbsp;&nbsp;Usar método de pago
                </b-form-checkbox>
                <br />
                <div v-for="(item, index) in tarjeta" v-bind:key="index">
                  <b-form-group
                    :label="'NÚMERO DE TRANSACCIÓN TARJETA' + ' ' + (index + 1)"
                    class="has-float-label"
                  >
                    <b-input-group>
                      <b-form-input
                        :disabled="!checkMoney.tarjeta"
                        :class="{
                          'is-invalid':
                            $v.tarjeta.$each.$iter[index].transaccion_tarjeta
                              .$error,
                        }"
                        v-model.trim="item.transaccion_tarjeta"
                        placeholder="Ingresar en número tarjeta"
                        @input="sumarCantidades()"
                      >
                      </b-form-input>
                      <b-input-group-append v-if="item.button">
                        <b-button
                          :disabled="!checkMoney.tarjeta"
                          variant="primary"
                          @click="onButton('tarjeta-plus')"
                          ><i :class="'bx bx-plus-medical'"
                        /></b-button>
                      </b-input-group-append>
                      <b-input-group-append v-if="!item.button">
                        <b-button
                          variant="primary"
                          @click="onButton('tarjeta-minus', index)"
                          ><i :class="'bx bx-undo'" />
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                    <div
                      v-if="checkMoney.tarjeta"
                      :class="{
                        'invalid-feedback': true,
                        'd-block':
                          $v.tarjeta.$each.$iter[index].transaccion_tarjeta
                            .$invalid &&
                          !$v.tarjeta.$each.$iter[index].transaccion_tarjeta
                            .$invalid.required,
                      }"
                    >
                      Debe ingresar el número de transacción de tarjeta
                    </div>
                  </b-form-group>
                  <br />
                  <b-form-group label="MONTO">
                    <masked-input
                      :disabled="!checkMoney.tarjeta"
                      v-model.trim="item.cantidad_tarjeta"
                      :mask="mask_quetzal"
                      :guide="false"
                      :keep-char-positions="true"
                      :show-mask="true"
                      type="text"
                      @input="sumarCantidades()"
                      placeholder="Ingresar el monto a pagar"
                      :class="{
                        'is-invalid':
                          $v.tarjeta.$each.$iter[index].cantidad_tarjeta.$error,
                      }"
                      class="form-control"
                    />
                    <div
                      v-if="checkMoney.tarjeta"
                      :class="{
                        'invalid-feedback': true,
                        'd-block':
                          $v.tarjeta.$each.$iter[index].cantidad_tarjeta
                            .$invalid &&
                          !$v.tarjeta.$each.$iter[index].cantidad_tarjeta
                            .$invalid.required,
                      }"
                    >
                      Debe ingresar el monto
                    </div>
                  </b-form-group>
                  <hr />
                </div>
              </b-card>
            </b-tab>
          </b-tabs>
          <br />
          <div class="row">
            <div class="col">
              <b-card bg-variant="primary" class="text-white-50 bg-gradient">
                <h4 class="mt-0 mb-4 text-white">
                  <i class="bx bx-money me-3"></i> Total a pagar
                </h4>
                <h3 class="mt-0 mb-4 text-white" align="center">
                  {{
                    money(
                      parseFloat(converMaskToNumberxd(formCredito.adelanto)) > 0
                        ? parseFloat(converMaskToNumberxd(formCredito.adelanto))
                        : 0.0
                    )
                  }}
                </h3>
              </b-card>
            </div>
            <div class="col">
              <b-card bg-variant="primary" class="text-white-50 bg-gradient">
                <h4 class="mt-0 mb-4 text-white">
                  <i class="bx bx-list-check me-3"></i> Restante de pago
                </h4>
                <h3 class="mt-0 mb-4 text-white" align="center">
                  {{
                    money(
                      parseFloat(converMaskToNumberxd(formCredito.adelanto)) > 0
                        ? parseFloat(
                            converMaskToNumberxd(formCredito.adelanto)
                          ) - montoFinal.cantidad
                        : 0.0
                    )
                  }}
                </h3>
              </b-card>
            </div>
            <div class="col">
              <b-card bg-variant="primary" class="text-white-50 bg-gradient">
                <h4 class="mt-0 mb-4 text-white">
                  <i class="bx bx-detail me-3"></i> Cantidad pagando
                </h4>
                <h3 class="mt-0 mb-4 text-white" align="center">
                  {{
                    money(montoFinal.cantidad >= 0 ? montoFinal.cantidad : 0.0)
                  }}
                </h3>
              </b-card>
            </div>
          </div>
        </b-collapse>
      </b-card>

      <template #modal-footer="{}">
        <b-button variant="primary" @click="validarModalCredito"
          >Aceptar
        </b-button>
        <b-button variant="danger" @click="$bvModal.hide('modalCredito')"
          >Cerrar
        </b-button>
      </template>
    </b-modal>

    <b-modal
      centered
      v-model="showModalL"
      title-class="text-black font-18"
      body-class="p-3"
      hide-footer
      no-close-on-backdrop
      content-class="my-class"
      header-class="my-class"
    >
      <template #modal-header="{}">
        <!-- Emulate built in modal header close button action -->

        <h5></h5>
      </template>
      <form>
        <div class="row">
          <div class="col-12">
            <div class="d-flex justify-content-center">
              <fulfilling-bouncing-circle-spinner
                :animation-duration="2000"
                :size="90"
                color="#2a3042"
              />
            </div>
          </div>
        </div>
      </form>
    </b-modal>
    <!-- <PageHeader :title="title" :items="items" /> -->
    <!-- ESTA PARTE ES PARA LA CABECERA -->
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col">
                <h4>NUEVA VENTA {{ showDate(new Date()) }}</h4>
              </div>
              <div class="col" align="center">
                <div class="mt-4 mt-sm-0">
                  <h3>
                    {{
                      formatQuetzales(formPro.total > 0 ? formPro.total : 0.0)
                    }}
                  </h3>
                  <p class="text-muted mb-2">Total</p>
                </div>
              </div>
              <div class="col" align="right">
              
              </div>
            </div>
            <div class="text-center">
                    <div class="row">
                      <div class="col-sm-4">
                        <div>
                          <p class="text-muted mb-2"><strong>Cliente</strong> </p>
                          <h5 class="font-size-15">{{ formPro.cliente }}</h5>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div>
                          <p class="text-muted mb-2"><strong>Vehiculo</strong></p>
                          <h5 class="font-size-15">{{ formPro.auto + ' ' + formPro.modelo + '::' + formPro.anio + '::'+formPro.placas }}</h5>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div>
                          <p class="text-muted mb-2"><strong>Observaciones Cliente</strong></p>
                          <h5 class="font-size-15">{{ formPro.observaciones }}</h5>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div>
                          <p class="text-muted mb-2"><strong>Observaciones Mecanico</strong></p>
                          <h5 class="font-size-15">{{ formPro.observacion_mecanico }}</h5>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div>
                          <p class="text-muted mb-2"><strong>Observaciones Reparación</strong></p>
                          <textarea
                                name="textarea"
                                v-model="formPro.observacion_general"
                                rows="2"
                                cols="40"
                            ></textarea>
                        </div>
                      </div>
                    </div>
                    <br />
                    <br />
                  
                      
                      <!-- <div class="col-sm-3">
                        <div class="mt-4 mt-sm-0">
                          <p class="text-muted mb-2">Usuario</p>
                          <h6 v-if="formPro.user != ''" class="font-size-15">
                            {{ formPro.user }}
                          </h6>
                          <h6 v-else class="font-size-15">Sin autorizar</h6>
                        </div>
                      </div> -->
                    <!-- </div> -->
                  </div>
            <br>
            <div class="text-center">
                <div align="center">
                    <div row justify-content-center>
                        <div class="btn-group" role="group" aria-label="Basic radio toggle button group">
                            <label
                                v-for="opcion in estadosRevision"
                                :key="opcion.id"
                                :class="['btn', 'btn-group-toggle', selectedOption === opcion.valor ? 'btn-primary' : '']"
                                >
                                <input
                                    type="radio"
                                    :id="'opcion-' + opcion.id"
                                    :value="opcion.valor"
                                    v-model="selectedOption"
                                    autocomplete="off"
                                />
                                {{ opcion.valor }}
                                </label>
                        </div>
                    </div>
                </div>
            </div>
          
            <br>
            <div class="text-center">
              <div align="center">
               
                <div class="row justify-content-center">
                 
                  <div class="col d-grid">
                    <b-button
                      block
                      size="md"
                      variant="primary"
                      @click="focus(1)"
                      v-b-modal.modalProductos
                    >
                      AGREGAR PRODUCTOS&nbsp;&nbsp;<i
                        class="bx bx-grid-alt"
                      ></i>
                    </b-button>
                  </div>
                  <div class="col d-grid gap-2">
                    <b-button
                      block
                      size="md"
                      variant="primary"
                      @click="focus(2)"
                      v-b-modal.modalServicios
                    >
                      AGREGAR SERVICIOS&nbsp;&nbsp;<i class="bx bx-car"></i>
                    </b-button>
                  </div>
                  <!-- <div class="col d-grid gap-2">
                    <b-button
                      block
                      size="md"
                      :variant="formCredito.color ? 'success' : 'danger'"
                      v-b-modal.modalCredito
                      @click="focus(3)"
                    >
                      {{
                        formCredito.asignado == true
                          ? "COBRO ASIGNADO"
                          : "AGREGAR COBRO"
                      }}&nbsp;&nbsp;<i class="bx bx-car"></i>
                    </b-button>
                  </div> -->
                </div>
                <br>
                <br>
                <b-table
                  small
                  striped
                  v-if="arrayDetalle.length > 0"
                  ref="table"
                  :items="arrayDetalle"
                  :fields="cabezera"
                >
                  <!-- <template #cell(producto)="data">
                      <a
                        :href="
                          apiUrl +
                          'productos/get/imagen/' +
                          data.item.imagen_stock
                        "
                        target="_blank"
                      >
                        {{ data.item.producto }}
                      </a>
                    </template> -->
                  <template #cell(codigo)="data">
                    {{ data.item.codigo }}
                  </template>
                  <template #cell(opciones)="data">
                    <b-button-group>
                      <b-button
                        class="icon-content col-xl-8 col-lg-4 col-sm-"
                        size="md"
                        variant="outline-danger"
                        @click="eliminarDetalle(data)"
                        ><i :class="'bx bx-undo'" />
                      </b-button>
                  
                    </b-button-group>
                  </template>
               
                  <template #cell(precio_venta)="data">
                    <div class="input-group">
                     
                       
                      <b-form-input
                      @keyup="cambiarCantidadPrecio(data)"
                      @input="cambiarCantidadPrecio(data)"
                        v-model="data.item.precio_venta"
                        placeholder="Precio venta"
                        type= "number"
                      ></b-form-input>
                    </div>
                  </template>
                  <template #cell(subtotal)="data">
                    {{
                      formatQuetzales(
                        data.item.subtotal > 0 ? data.item.subtotal : 0.0
                      )
                    }}
                  </template>
                  <template #cell(cantidad)="data">
                    <b-form-input
                      @keyup="cambiarCantidadPrecio(data)"
                      @input="cambiarCantidadPrecio(data)"
                      v-model="data.item.cantidad"
                      placeholder="Ingrese la cantidad"
                      type= "number"
                    ></b-form-input>
                  </template>
                  <template #cell(existencia)="data">
                    {{ data.item.existencia_actual }}
                  </template>
                </b-table>

                <b-card v-if="formPro.total_productos > 0" no-body>
                  <b-row m-2>
                    <b-col align="left"
                      ><h4 align="left">
                        <i class="bx bxl-product-hunt"></i>&nbsp;&nbsp;Total
                        productos
                      </h4></b-col
                    >
                    <b-col align="right">
                      <h4>
                        {{
                          formatQuetzales(
                            formPro.total_productos > 0
                              ? formPro.total_productos
                              : 0.0
                          )
                        }}
                      </h4>
                    </b-col>
                  </b-row>
                </b-card>

                <h5 v-if="arrayDetalleServicio.length > 0" class="pt-3">
                  &nbsp;&nbsp;&nbsp;Servicios
                </h5>
                <b-table
                  striped
                  small
                  v-if="arrayDetalleServicio.length > 0"
                  ref="table2"
                  :items="arrayDetalleServicio"
                  :fields="cabezera2"
                >
                  <template #cell(opciones)="data">
                    <b-button
                      tabindex="0"
                      v-b-tooltip.focus
                      title="Eliminar"
                      class="icon-content col-xl-8 col-lg-4 col-sm-"
                      size="md"
                      variant="outline-danger"
                      @click="eliminarDetalleServicio(data)"
                      ><i :class="'bx bx-undo'"
                    /></b-button>
                  </template>
                  <template #cell(precio_venta)="data">
                    <b-form-input
                      @keyup="sumarCantidadServicio(data)"
                      @input="sumarCantidadServicio(data)"
                      v-model="data.item.precio_venta"
                      type= "number"
                      placeholder="Precio compra"
                    ></b-form-input>
                  </template>
                  <template #cell(subtotal)="data">
                    {{
                      formatQuetzales(
                        data.item.subtotal > 0 ? data.item.subtotal : 0.0
                      )
                    }}
                  </template>

                  <template #cell(cantidad)="data">
                    <b-form-input
                      @keyup="sumarCantidadServicio(data)"
                      @input="sumarCantidadServicio(data)"
                      v-model="data.item.cantidad"
                      type="number"
                      placeholder="Cantidad"
                    ></b-form-input>
                  </template>
                </b-table>
                <b-card v-if="formPro.total_servicios > 0" no-body>
                  <b-row m-2>
                    <b-col align="left"
                      ><h4 align="left">
                        <i class="bx bx-wrench"></i>&nbsp;&nbsp;Total servicios
                      </h4></b-col
                    >
                    <b-col align="right">
                      <h4>
                        {{
                          formatQuetzales(
                            formPro.total_servicios > 0
                              ? formPro.total_servicios
                              : 0.0
                          )
                        }}
                      </h4>
                    </b-col>
                  </b-row>
                </b-card>
              </div>

              <!-- Botones -->
              <div class="col-sm-12 pt-3">
                <div class="row">
                  <div class="col">
                    <router-link
                      class="d-grid gap-2"
                      :to="{
                        name: 'taller',
                      }"
                    >
                      <b-button
                        block
                        size="lg"
                        variant="outline-primary"
                        type="button"
                        class="btn btn-rounded mb-2 me-2"
                      >
                        <i class="bx bx-arrow-back"></i>&nbsp;&nbsp;<b
                          >REGRESAR</b
                        >
                      </b-button>
                    </router-link>
                  </div>
                  <div class="col d-grid gap-2">
                    <b-button
                      block
                      size="lg"
                      variant="outline-success"
                      class="btn btn-rounded mb-2 me-2"
                      @click="validaciones('save')"
                    >
                      {{ tomandototal() }}
                      <i class="mdi mdi-truck-fast me-1"></i>
                      &nbsp;&nbsp;<b>GUARDAR</b>
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end card -->
    </div>
    <!-- end col -->
  </Layout>
</template>


<style scoped>
.btn-group-toggle .btn {
  margin-right: 0.5rem;
}

.btn-group-toggle .btn input[type="radio"] {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}

/* Estilo para la opción seleccionada */
.btn-group-toggle .btn.btn-primary {
  color: white; /* Color del texto para la opción seleccionada */
}

</style>